import React from "react";
import styled from "styled-components";
import { Table } from "components/bootstrap";
import { Section } from "components/common";
import FeatureModelRow from "./FeatureModelRow";
const GroupSection = styled(Section)`
  background-color: ${({ theme }) => theme.colors.global.contentBackground};
  margin-bottom: ${({ theme }) => theme.spacings.md};
`;
const FeatureCount = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fonts.size.small};
  font-weight: normal;
`;
const FeaturesTable = styled(Table)`
  margin-bottom: 0;
`;
const FeatureModelGroup = ({ name, features, providers }) => /* @__PURE__ */ React.createElement(
  GroupSection,
  {
    title: name,
    titleAs: "h2",
    collapsible: true,
    headerLeftSection: /* @__PURE__ */ React.createElement(FeatureCount, null, features.length, " ", features.length === 1 ? "feature" : "features")
  },
  /* @__PURE__ */ React.createElement(FeaturesTable, { condensed: true, responsive: true }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Feature"), /* @__PURE__ */ React.createElement("th", null, "Provider"), /* @__PURE__ */ React.createElement("th", null, "Model"))), /* @__PURE__ */ React.createElement("tbody", null, features.map((feature) => /* @__PURE__ */ React.createElement(FeatureModelRow, { key: feature.feature_id, feature, providers }))))
);
export default FeatureModelGroup;
